// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "feature-app." + chunkId + "." + {"161":"acebed2899298d8e3e7c","986":"8840670dac0f86370fe2"}[chunkId] + ".css";
};